import type * as ngCore from '@angular/core'

import * as routeBound from '../route-bound'

import * as dimensionFilter from './dimension-filter'
import * as full from './full'
import * as lite from './lite'
import * as organizations from './organizations'
import * as reports from './reports'
import * as roomTypes from './room-types'
import * as surveyConfiguration from './survey-configuration'
import * as userAccess from './user-access'

export {
  dimensionFilter,
  full,
  lite,
  organizations,
  reports,
  roomTypes,
  surveyConfiguration,
  userAccess,
}

export function provideEntityCollections(): ngCore.Provider[] {
  return [
    routeBound.Registry.provideDestroyable(organizations.Feature),
    roomTypes.Api,
    routeBound.Registry.provideDestroyable(roomTypes.Collection),
    reports.Api,
    routeBound.Registry.provideDestroyable(reports.Collection),
    reports.plugins.download.Api,
    dimensionFilter.plugin.Api,

    full.clusters.Api,
    routeBound.Registry.provideDestroyable(full.clusters.Collection),
    full.clusterAssignableRecords.Api,
    routeBound.Registry.provideDestroyable(
      full.clusterAssignableRecords.Collection,
    ),
    full.clusterAssignedRecords.Api,
    routeBound.Registry.provideDestroyable(
      full.clusterAssignedRecords.Collection,
    ),
    full.clusters.plugins.functionalUsage.Api,
    full.clusters.plugins.warnings.Api,
    full.employee.Api,
    routeBound.Registry.provideDestroyable(full.employee.Collection),
    full.functions.Api,
    routeBound.Registry.provideDestroyable(full.functions.Collection),
    full.jobTitles.Api,
    routeBound.Registry.provideDestroyable(full.jobTitles.Collection),
    full.clusterOccupants.Api,
    routeBound.Registry.provideDestroyable(full.clusterOccupants.Collection),
    full.recordOccupants.Api,
    routeBound.Registry.provideDestroyable(full.recordOccupants.Collection),
    full.persons.Api,
    routeBound.Registry.provideDestroyable(full.persons.Collection),
    full.recordAssignableLabs.Api,
    routeBound.Registry.provideDestroyable(
      full.recordAssignableLabs.Collection,
    ),
    full.recordAssignedOrgs.Api,
    routeBound.Registry.provideDestroyable(full.recordAssignedOrgs.Collection),
    full.recordLabAssignments.Api,
    routeBound.Registry.provideDestroyable(
      full.recordLabAssignments.Collection,
    ),
    full.records.Api,
    routeBound.Registry.provideDestroyable(full.records.Collection),
    full.records.plugins.bulkComment.Api,
    full.records.plugins.bulkFunctionalUsage.Api,
    full.records.plugins.bulkResponsiblePersons.Api,
    full.records.plugins.clusterAssignment.Api,
    full.records.plugins.functionalUsage.Api,
    full.records.plugins.surveyStatus.Api,
    full.records.plugins.warnings.Api,
    full.clusterResponsiblePersons.Api,
    routeBound.Registry.provideDestroyable(
      full.clusterResponsiblePersons.Collection,
    ),
    full.recordResponsiblePersons.Api,
    routeBound.Registry.provideDestroyable(
      full.recordResponsiblePersons.Collection,
    ),
    full.serviceCenters.Api,
    routeBound.Registry.provideDestroyable(full.serviceCenters.Collection),
    full.unassignedSponsoredAccounts.Api,
    routeBound.Registry.provideDestroyable(
      full.unassignedSponsoredAccounts.Collection,
    ),
    full.unassignedSponsoredPeople.Api,
    routeBound.Registry.provideDestroyable(
      full.unassignedSponsoredPeople.Collection,
    ),

    lite.persons.Api,
    routeBound.Registry.provideDestroyable(lite.persons.Collection),
    lite.recordAssignedOrgs.Api,
    routeBound.Registry.provideDestroyable(lite.recordAssignedOrgs.Collection),
    lite.records.Api,
    routeBound.Registry.provideDestroyable(lite.records.Collection),
    lite.records.plugins.functionalUsage.Api,
    lite.records.plugins.surveyStatus.Api,

    // Shared between Space Full and Space Lite
    surveyConfiguration.Api,
    routeBound.Registry.provideDestroyable(surveyConfiguration.Feature),
    userAccess.surveyAdmins.Api,
    routeBound.Registry.provideDestroyable(userAccess.surveyAdmins.Collection),
    userAccess.standardUsers.Api,
    routeBound.Registry.provideDestroyable(userAccess.standardUsers.Collection),
    userAccess.users.Api,
    routeBound.Registry.provideDestroyable(userAccess.users.Collection),
  ]
}
